import * as d3 from "d3";
import faker from 'faker';

import './timeline.css';

let timer;
let dataset;
let svg;
let playButton;
let x;
let slider;
let plot;
let handle;
let label;

let drawCallback;

const formatDateIntoYear = d3.time.format("%Y");
const formatDate = d3.time.format("%b %Y");

let startDate = new Date("2016-01-01"),
    endDate = new Date("2018-05-01");

let previousDate = startDate;

let margin = { top: 30, right: 50, bottom: 0, left: 150 },
    width = 800 - margin.left - margin.right,
    height = 250 - margin.top - margin.bottom;

////////// slider //////////

let moving = false;
let currentValue = 0;
let targetValue = width;

export const drawTimeline = (containerElementId, initData, playCallback, playbackFinishedCallback) => {

    drawCallback = playCallback;

    svg = d3.select(containerElementId)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom);

    playButton = d3.select("#play-button");

    x = d3.time.scale()
        .domain([startDate, endDate])
        .range([0, targetValue])
        .clamp(true);

    slider = svg.append("g")
        .attr("class", "slider")
        .attr("transform", "translate(" + margin.left + "," + height / 5 + ")");

    slider.append("line")
        .attr("class", "track")
        .attr("x1", x.range()[0])
        .attr("x2", x.range()[1])
        .select(function () { return this.parentNode.appendChild(this.cloneNode(true)); })
        .attr("class", "track-inset")
        .select(function () { return this.parentNode.appendChild(this.cloneNode(true)); })
        .attr("class", "track-overlay");
    // .call(d3.drag()
    //     .on("start.interrupt", function () { slider.interrupt(); })
    //     .on("start drag", function () {
    //         currentValue = d3.event.x;
    //         update(x.invert(currentValue));
    //     })
    // );

    slider.insert("g", ".track-overlay")
        .attr("class", "ticks")
        .attr("transform", "translate(0," + 18 + ")")
        .selectAll("text")
        .data(x.ticks(10))
        .enter()
        .append("text")
        .attr("x", x)
        .attr("y", 10)
        .attr("text-anchor", "middle")
        .text(function (d) { return formatDate(d); });

    handle = slider.insert("circle", ".track-overlay")
        .attr("class", "handle")
        .attr("r", 9);

    label = slider.append("text")
        .attr("class", "label")
        .attr("text-anchor", "middle")
        .text(formatDate(startDate))
        .attr("transform", "translate(0," + (-25) + ")")


    ////////// plot //////////

    plot = svg.append("g")
        .attr("class", "plot")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    dataset = generateData(initData);

    playButton
        .on("click", function () {
            const button = d3.select(this);
            if (button.attr('data-on') === "true") {
                moving = true;
                clearInterval(timer);
                // timer = 0;
                //button.text("Play");
                button.attr('data-on', "false");
            } else {
                moving = false;
                timer = setInterval(step.bind(null, playbackFinishedCallback), 50);
                //button.text("Pause");
                button.attr('data-on', "true");
            }
            //console.log("Slider moving: " + moving);
        });

    //drawCallback(dataset);
}

const generateData = (endJourney) => {
    const length = 60;

    let data = [];

    for (let i = 0; i < length; i++) {
        let simulatedRecord = {};
        simulatedRecord.id = i;
        simulatedRecord.date = faker.date.between(startDate, endDate);
        data.push(simulatedRecord);
    }

    data.sort((a, b) => d3.descending(a.date, b.date));
    startDate = d3.min(data.map(d => d.date));
    endDate = d3.max(data.map(d => d.date));

    const enterThresholds = endJourney.map(e => e.enter.value);
    const exitThresholds = endJourney.map(e => e.exit.value);
    let previousJourney = enterThresholds;

    data.map((record, index) => {
        record.journey = [];
        endJourney.forEach((sourceJourney, y) => {

            const enterMax = Math.min(previousJourney[y], enterThresholds[y]);
            const enterValue = faker.random.number({ min: enterMax * 0.9, max: enterMax });

            const simulatedJourney = {
                enter: {
                    label: sourceJourney.enter.label,
                    value: enterValue
                },
                exit: {
                    label: sourceJourney.exit.label,
                    value: enterValue
                }
            };

            previousJourney[y] = enterValue;
            record.journey.push(simulatedJourney);
        });
    });

    // adding the source record at the end
    data.unshift({ id: length + 1, date: endDate, journey: endJourney });

    //data.forEach(entry => console.log(entry.date + ': ' + entry.journey.map(e => e.enter.value + ', ')));
    return data;
}

function step(doneCallback) {
    update(x.invert(currentValue));
    currentValue = currentValue + (targetValue / 151);
    // done
    if (currentValue > targetValue) {
        moving = false;
        currentValue = 0;
        clearInterval(timer);
        // timer = 0;
        d3.select("#play-button").attr('data-on', "false");

        previousDate = startDate;

        // TODO: reset the handle after complete?
        //handle.attr("cx", 0);
        doneCallback();
        console.log("Slider moving: " + moving);
    }
}

// function drawPlot(data) {
//     const locations = plot.selectAll(".location")
//         .data(data);

//     // if filtered dataset has more circles than already existing, transition new ones in
//     locations.enter()
//         .append("circle")
//         .attr("class", "location")
//         .attr("cx", function (d) {
//             return x(d.date);
//         })
//         .attr("cy", height / 2)
//         .style("fill", function (d) { return d3.hsl(d.date / 1000000000, 0.8, 0.8) })
//         .style("stroke", function (d) { return d3.hsl(d.date / 1000000000, 0.7, 0.7) })
//         .style("opacity", 0.5)
//         .attr("r", 8)
//         .transition()
//         .duration(400)
//         .attr("r", 25)
//         .transition()
//         .attr("r", 8);

//     // if filtered dataset has less circles than already existing, remove excess
//     locations.exit()
//         .remove();
// }

function update(h) {

    // update position and text of label according to slider scale
    handle.attr("cx", x(h));
    label
        .attr("x", x(h))
        .text(formatDate(h));

    // filter data set and redraw plot
    let newData = dataset.filter(function (d) {
        const found = d.date <= h && d.date > previousDate;
        if (found) previousDate = d.date;
        return found;
    });

    if (newData && newData.length > 0) {
        drawCallback(newData[newData.length - 1].journey);
    }
}


// WEBPACK FOOTER //
// ./src/charts/Timeline.js